export default {
  configurations: "Configurations",
  dark_mode: "Dark mode",
  dark_mode_true_label: "On",
  dark_mode_false_label: "Off",
  dark_mode_indeterminate_label: "Match system settings",
  easterEggs_false_label: "No adventures for me, thank you. Not today.",
  easterEggs_true_label: "I’m going on an adventure!",
  easterEgg_notification: "There is always more about you than anyone expects!",
  internet_connectivity: "General internet connectivity",
  internet_false_label: "Mostly offline",
  internet_true_label: "Mostly online",
  issues: "Press on <b>Issues (#)</b>, Items/Areas",
  language_select_label: "Language",
  last_connection: "Last Cloud connection",
  location_select: "Selecting <b>Location</b> for an <b>Item</b>",
  location_select_false_label: "By marker on Layout",
  location_select_true_label: "Search and Filter",
  notifications: "Enable animation on notifications bell",
  download_all_data: "Download all non-file data on Workspace start-up",
  performed_work:
    "When all required <b>Issues</b> have been raised after <b>Performed Work</b> the work is always done.",
  prioritize_data: "Prioritize data and files related to my assigned <b>Work Orders</b>",
  set_password: "Set Password",
  set_unlock_key: "Set Unlock Key",
  skip_list: "Skip lists with only 1 Object and go to Object overview",
  title: "User Settings",
  title_change_password: "Change password",
  title_change_unlock_key: "Change Unlock Key",
  title_configurations: "Configurations",
  title_data_transfer: "Data transfer and prioritization settings",
  title_info: "Information",
  title_interface: "Interface and configuration",
  title_other: "Other stuff",
  title_security: "Security",
  title_workflow: "Workflow configuration",
  trinary_false_label: "Open the filtered Issues list",
  trinary_indeterminate_label: "Let me choose each time",
  trinary_true_label: "Perform Work immediately, top-down",
  tutorial: "Show tips and tricks",
  version: "Installed version",
  work_orders: "Press on <b>Work Orders (#)</b>, Items/Areas",
}
